module.exports = __webpack_public_path__ + "4ce7714d137dd3552046c855cfb2039f.svg";